/* eslint-disable react/prop-types */
import { Check, Circle, CircleDot } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from 'src/features/tyre-management/components/ui/button';

const StepIcon = ({ status }) => {
  if (status === 'complete') return <Check aria-hidden="true" />;
  if (status === 'current') return <CircleDot aria-hidden="true" />;
  return <Circle aria-hidden="true" />;
};

const TyreSetupJourney = ({ journey, justCreated }) => {
  if (!journey.visible) return null;

  return (
    <section className="vd-setup-journey" aria-label="Vehicle tyre setup progress">
      <div className="vd-setup-journey__copy">
        {justCreated && <p className="vd-eyebrow">Vehicle created</p>}
        <h2>{journey.title}</h2>
        <p>{journey.description}</p>
      </div>
      <ol className="vd-setup-journey__steps">
        {journey.steps.map((step) => (
          <li key={step.id} data-status={step.status}>
            <span><StepIcon status={step.status} /></span>
            <strong>{step.label}</strong>
          </li>
        ))}
      </ol>
      {(journey.primaryAction || journey.secondaryAction) && (
        <div className="vd-setup-journey__actions">
          {journey.primaryAction && (
            <Button asChild><Link to={journey.primaryAction.href}>{journey.primaryAction.label}</Link></Button>
          )}
          {journey.secondaryAction && (
            <Button variant="outline" asChild><Link to={journey.secondaryAction.href}>{journey.secondaryAction.label}</Link></Button>
          )}
        </div>
      )}
    </section>
  );
};

export default TyreSetupJourney;
